import { Tabs } from 'components/ideal-core-ui'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { Deals } from './Deals'
import { Proposals } from './Proposals'
import { Checklists } from './Checklists'
import { ContactNotes } from './ContactNotes'
import { ContactSpend } from './ContactSpend'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import s from './ContactTabs.scss'

const selectDeals = createSelector([state => state.deals], deals => {
  return deals
})

const selectLostDeals = createSelector([state => state.lostDeals], deals => {
  return deals
})

const selectClosedDeals = createSelector([state => state.closedDeals], deals => {
  return deals
})

const selectProjectDeals = createSelector([state => state.projectDeals], deals => {
  return deals
})

const selectWonDeals = createSelector([state => state.wonDeals], deals => {
  return deals
})

const selectProposals = createSelector([state => state.proposals], proposals => {
  return proposals
})

const selectWonProposals = createSelector([state => state.wonProposals], proposals => {
  return proposals
})

const selectLostProposals = createSelector([state => state.lostProposals], proposals => {
  return proposals
})

const ContactTabs = ({ contact }) => {
  const deals = useSelector(state => selectDeals(state.contact))
  const lostDeals = useSelector(state => selectLostDeals(state.contact))
  const closedDeals = useSelector(state => selectClosedDeals(state.contact))
  const wonDeals = useSelector(state => selectWonDeals(state.contact))
  const projectDeals = useSelector(state => selectProjectDeals(state.contact))
  const proposals = useSelector(state => selectProposals(state.contact))
  const wonProposals = useSelector(state => selectWonProposals(state.contact))
  const lostProposals = useSelector(state => selectLostProposals(state.contact))

  const location = useLocation()
  const { tab } = queryString.parse(location.search)

  const { id, firstName, lastName } = contact

  return (
    <Tabs
      withUpdateUrl
      className={s.main}
      activeTabKey={tab || 'deals'}
      noPadding
      tabs={[
        {
          key: 'deals',
          label: 'Opportunities with this contact',
          value: (
            <Deals
              deals={deals}
              lostDeals={lostDeals}
              closedDeals={closedDeals}
              wonDeals={wonDeals}
              projectDeals={projectDeals}
              contact={contact}
            />
          )
        },
        {
          key: 'proposals',
          label: 'Proposals with this contact',
          value: (
            <Proposals
              proposals={proposals}
              wonProposals={wonProposals}
              lostProposals={lostProposals}
              contact={contact}
            />
          )
        },
        {
          key: 'checklists',
          label: 'Checklists',
          value: <Checklists />
        },
        {
          key: 'notes',
          label: 'Notes',
          value: <ContactNotes contactId={id} contactName={`${firstName} ${lastName}`} />
        },
        {
          key: 'spend',
          label: 'Spend',
          value: <ContactSpend id={id} />
        }
      ]}
    />
  )
}

export default ContactTabs
